// src/components/SponsorLogos.js
import React from 'react';
import './SponsorLogos.css';

/**
 * Renders a strip of sponsor logos as links to their websites.
 * @param {Object} props
 * @param {Array} props.sponsors - Array of { id, name, website, logo }
 * @param {'subtle'|'puzzle'} props.variant - 'subtle' for dashboards, 'puzzle' for puzzle page
 */
const SponsorLogos = ({ sponsors = [], variant = 'subtle' }) => {
  if (!sponsors || sponsors.length === 0) return null;

  const className = `sponsor-logos sponsor-logos--${variant}`;

  return (
    <div className={className} aria-label="Sponsors">
      <div className="sponsor-logos-inner">
        {sponsors.map((s) => {
          const href = (s.website || '').trim() || '#';
          const logoUrl = (s.logo || '').trim();
          const useLogo = logoUrl && !logoUrl.includes('drive.google.com');
          const content = useLogo ? (
            <img src={logoUrl} alt={s.name || 'Sponsor'} className="sponsor-logos-img" />
          ) : (
            <span className="sponsor-logos-name">{s.name || 'Sponsor'}</span>
          );
          return (
            <a
              key={s.id}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="sponsor-logos-link"
              title={s.name || ''}
            >
              {content}
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default SponsorLogos;
